var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "my-editor" },
    [
      _vm.showToolbar
        ? _c("toolbar", {
            staticClass: "toolbar",
            attrs: { editor: _vm.editor, "default-config": _vm.toolbarConfig },
          })
        : _vm._e(),
      _c("editor", {
        staticClass: "editor-wrapper",
        attrs: { "default-config": _vm.editorConfig },
        on: { onCreated: _vm.onCreated, onChange: _vm.onChange },
        model: {
          value: _vm.htmlValue,
          callback: function ($$v) {
            _vm.htmlValue = $$v
          },
          expression: "htmlValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }